import { ValidationMessageTemplate } from 'vee-validate/dist/types/types';
import { ValidatorNames } from '@/../types/validator';

const ja = require('vee-validate/dist/locale/ja.json');

const messages: { [key in ValidatorNames]: ValidationMessageTemplate } = {
  // vee-validator's
  email: '有効なメールアドレスではありません',
  required: '{_field_}は必須項目です',
  min: '{_field_}は{length}文字以上でなければなりません',

  // custom
  equal: '{_field_}が一致しません',
  optional_date: field =>
    `${field}は「yyyy」「yyyy-MM」「yyyy-MM-dd」のいずれかの形式で入力してください。`,
  original_path: field =>
    `${field}は半角英数字「_」「-」のみ使用できます(記号のみは不可)`,
  required_checkbox: '{_field_}を確認してください',
  url: '{_field_}は有効なURLではありません',
};

export default {
  messages,
};
